import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../../assets/css/general/navbar.css";
import logo from '../../assets/images/logo.jpg';

const NavigationBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [topbarVisible, setTopbarVisible] = useState(true);
  const [isTransparent, setIsTransparent] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [userData, setUserData] = useState(null);

  const TOPBAR_H = 40;
  const NAVBAR_H = 70;

  useEffect(() => {
    const role = localStorage.getItem('userRole');
    const name = localStorage.getItem('userName') || 'Customer';
    const email = localStorage.getItem('userEmail') || '';
    const avatar =
      localStorage.getItem('userAvatar') ||
      `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=2C5F7C&color=fff`;

    if (role === 'customer' || role === 'vendor') {
      setIsLoggedIn(true);
      setUserData({ name, email, avatar, role });
    } else {
      setIsLoggedIn(false);
      setUserData(null);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showProfileDropdown && !event.target.closest('.hn-profile-wrap')) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showProfileDropdown]);

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY;
      setTopbarVisible(scrollY < TOPBAR_H);

      const navBottom = NAVBAR_H;
      const darkSections = document.querySelectorAll(
        '.hero-section, .dark-section, [data-navbar="dark"]'
      );

      let overDark = false;
      if (darkSections.length > 0) {
        darkSections.forEach((sec) => {
          const rect = sec.getBoundingClientRect();
          if (rect.top <= navBottom && rect.bottom > 0) overDark = true;
        });
      } else {
        overDark = scrollY < window.innerHeight * 0.5;
      }

      setIsTransparent(overDark);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const scrollToSection = (id) => {
    setIsMobileMenuOpen(false);
    if (location.pathname === '/') {
      const el = document.getElementById(id);
      if (el) {
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.pageYOffset - 80,
          behavior: 'smooth',
        });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          window.scrollTo({
            top: el.getBoundingClientRect().top + window.pageYOffset - 80,
            behavior: 'smooth',
          });
        }
      }, 300);
    }
  };

  const go = (path) => {
    setIsMobileMenuOpen(false);
    navigate(path);
  };

  const getDashboardPath = () => {
    const role = localStorage.getItem('userRole');
    if (role === 'vendor') {
      return '/vendor/hotel-dashboard';
    }
    return '/customer/dashboard';
  };

  const logout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("customerEmail");
  localStorage.removeItem("customerPassword");
  localStorage.removeItem("userRole");
  localStorage.removeItem("customerId");
  localStorage.removeItem("userName");

  navigate("/auth/login", { replace: true });
  };

  const toggleDropdown = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };

  const navClass = [
    'hn-navbar',
    topbarVisible ? 'hn-below-topbar' : 'hn-top',
    isTransparent ? 'hn-transparent' : 'hn-solid',
  ].join(' ');

  const navItems = [
    { label: 'HOME',         action: () => go('/'),             activePath: '/' },
    { label: 'ABOUT US',     action: () => scrollToSection('about'), activePath: null },
    { label: 'PACKAGES',     action: () => go('/Packages'),     activePath: '/Packages' },
    { label: 'DESTINATIONS', action: () => go('/destinations'), activePath: '/destinations' },
    { label: 'FOOD BLOGS',   action: () => go('/food-blogs'),   activePath: '/food-blogs' },
    { label: 'EVENTS',       action: () => go('/eventblogs'),   activePath: '/events-blogs' },
    { label: 'HOTELS',       action: () => go('/hotels'),       activePath: '/hotels' },
    { label: 'AI PLANNER',   action: () => go('/aiplanner'),    activePath: '/ai-planner' },
  ];

  return (
    <nav className={navClass}>
      <div className="hn-container">
        <div className="hn-content">

          <div className="hn-logo-wrap" onClick={() => go('/')}>
          <img src={logo} alt="Journey Junction" className="hn-logo-img" />
          <h1 className="hn-logo">JOURNEY JUNCTION</h1>
         </div>
          {/* DESKTOP MENU */}
          <div className="hn-menu">
            {navItems.map((item) => (
              <a
                key={item.label}
                className={`hn-link${item.activePath && isActive(item.activePath) ? ' hn-active' : ''}`}
                onClick={item.action}
              >
                {item.label}
              </a>
            ))}

            {/* Auth Section */}
            {!isLoggedIn ? (
              <button className="hn-btn-register" onClick={() => go('/auth/login')}>
                LOGIN / REGISTER
              </button>
            ) : (
              <div className="hn-profile-wrap">
                <button className="hn-profile-trigger" onClick={toggleDropdown}>
                  <img src={userData.avatar} alt={userData.name} className="hn-avatar" />
                  <span className="hn-pname">{userData.name}</span>
                  <span className={`hn-chev ${showProfileDropdown ? 'up' : ''}`}>▾</span>
                </button>

                {showProfileDropdown && (
                  <div className="hn-profile-menu">
                    <div className="hn-ph">
                      <img src={userData.avatar} alt={userData.name} />
                      <div>
                        <h4>{userData.name}</h4>
                        <p>{userData.email}</p>
                      </div>
                    </div>
                    <div className="hn-divider" />
                    <a 
                      className="hn-pi" 
                      onClick={() => {
                        setShowProfileDropdown(false);
                        navigate(getDashboardPath());
                      }}
                    >
                      My Dashboard
                    </a>
                    <div className="hn-divider" />
                    <a 
                      className="hn-pi hn-pi-logout" 
                      onClick={() => {
                        setShowProfileDropdown(false);
                        logout();
                      }}
                    >
                      Logout
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>

          <button
            className="hn-ham-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            <span className={`hn-ham ${isMobileMenuOpen ? 'open' : ''}`}>
              <span /><span /><span />
            </span>
          </button>
        </div>

        <div className={`hn-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
          {navItems.map((item) => (
            <a
              key={item.label}
              className={`hn-ml${item.activePath && isActive(item.activePath) ? ' hn-ml-active' : ''}`}
              onClick={item.action}
            >
              {item.label}
            </a>
          ))}

          {!isLoggedIn ? (
            <a className="hn-ml hn-ml-reg" onClick={() => go('/auth/login')}>
              LOGIN / REGISTER
            </a>
          ) : (
            <>
              <div className="hn-mob-user">
                <img src={userData.avatar} alt={userData.name} />
                <div>
                  <h4>{userData.name}</h4>
                  <p>{userData.email}</p>
                </div>
              </div>
              <a 
                className="hn-ml" 
                onClick={() => {
                  setShowProfileDropdown(false);
                  navigate(getDashboardPath());
                }}
              >
                My Dashboard
              </a>
              <a 
                className="hn-ml hn-ml-logout" 
                onClick={() => {
                  setShowProfileDropdown(false);
                  logout();
                }}
              >
                Logout
              </a>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;